import { FC } from "react";
import { useOutletContext } from "react-router-dom";
import { UserPageOutletContext } from "../index";
import { UserGoodsControlTabContent } from "./content";

export const UserGoodsControlTab: FC<any> = () => {
  const [user] = useOutletContext<UserPageOutletContext>();
  return <UserGoodsControlTabContent user={user} />;
};
